<div [class]="'bg-landing-banner ' + dir">
  <div class="relative">
    <div class="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
      <div class="text-center">
        <h1
          class="text-3xl font-bold text-white sm:text-5xl 2xl:leading-[4rem]"
        >
          {{ "BANNER.DIGITAL" | translate }}
        </h1>
        <p class="my-12 2xl:text-2xl text-lg text-white 2xl:leading-10">
          {{ "BANNER.MODERN" | translate }}
        </p>
        <div class="flex items-center justify-center gap-x-6">
          <a
            class="bg-primary rounded-md px-3.5 py-2.5 text-white shadow-sm hover:bg-primary hover:cursor-pointer"
            (click)="enquiryForm()"
            >{{ "BANNER.GETCARD" | translate }}</a
          >
        </div>
      </div>
    </div>
  </div>
</div>


